import { c as _c } from "react/compiler-runtime";
import { IcoArrowTopRight16 } from '@onefootprint/icons';
import { Dialog, LinkButton } from '@onefootprint/ui';
import { Trans, useTranslation } from 'react-i18next';
type CelInstructionsDialogProps = {
  open: boolean;
  onClose: () => void;
};
type Example = {
  description: string;
  expression: string;
};
const CelInstructionsDialog = t0 => {
  const $ = _c(185);
  const {
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "celInstructions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      description: t2,
      expression: t3
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp3);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp4);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = {
      description: t5,
      expression: t6
    };
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp5);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp6);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = {
      description: t8,
      expression: t9
    };
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t(_temp7);
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t(_temp8);
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = {
      description: t11,
      expression: t12
    };
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t(_temp9);
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t) {
    t15 = t(_temp10);
    $[31] = t;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t14 || $[34] !== t15) {
    t16 = {
      description: t14,
      expression: t15
    };
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t) {
    t17 = t(_temp11);
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t) {
    t18 = t(_temp12);
    $[38] = t;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t17 || $[41] !== t18) {
    t19 = {
      description: t17,
      expression: t18
    };
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t) {
    t20 = t(_temp13);
    $[43] = t;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t) {
    t21 = t(_temp14);
    $[45] = t;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t20 || $[48] !== t21) {
    t22 = {
      description: t20,
      expression: t21
    };
    $[47] = t20;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t) {
    t23 = t(_temp15);
    $[50] = t;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t) {
    t24 = t(_temp16);
    $[52] = t;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t23 || $[55] !== t24) {
    t25 = {
      description: t23,
      expression: t24
    };
    $[54] = t23;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t) {
    t26 = t(_temp17);
    $[57] = t;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[59] !== t) {
    t27 = t(_temp18);
    $[59] = t;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t26 || $[62] !== t27) {
    t28 = {
      description: t26,
      expression: t27
    };
    $[61] = t26;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== t) {
    t29 = t(_temp19);
    $[64] = t;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t) {
    t30 = t(_temp20);
    $[66] = t;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t29 || $[69] !== t30) {
    t31 = {
      description: t29,
      expression: t30
    };
    $[68] = t29;
    $[69] = t30;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== t) {
    t32 = t(_temp21);
    $[71] = t;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] !== t) {
    t33 = t(_temp22);
    $[73] = t;
    $[74] = t33;
  } else {
    t33 = $[74];
  }
  let t34;
  if ($[75] !== t32 || $[76] !== t33) {
    t34 = {
      description: t32,
      expression: t33
    };
    $[75] = t32;
    $[76] = t33;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== t) {
    t35 = t(_temp23);
    $[78] = t;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  let t36;
  if ($[80] !== t) {
    t36 = t(_temp24);
    $[80] = t;
    $[81] = t36;
  } else {
    t36 = $[81];
  }
  let t37;
  if ($[82] !== t35 || $[83] !== t36) {
    t37 = {
      description: t35,
      expression: t36
    };
    $[82] = t35;
    $[83] = t36;
    $[84] = t37;
  } else {
    t37 = $[84];
  }
  let t38;
  if ($[85] !== t) {
    t38 = t(_temp25);
    $[85] = t;
    $[86] = t38;
  } else {
    t38 = $[86];
  }
  let t39;
  if ($[87] !== t) {
    t39 = t(_temp26);
    $[87] = t;
    $[88] = t39;
  } else {
    t39 = $[88];
  }
  let t40;
  if ($[89] !== t38 || $[90] !== t39) {
    t40 = {
      description: t38,
      expression: t39
    };
    $[89] = t38;
    $[90] = t39;
    $[91] = t40;
  } else {
    t40 = $[91];
  }
  let t41;
  if ($[92] !== t) {
    t41 = t(_temp27);
    $[92] = t;
    $[93] = t41;
  } else {
    t41 = $[93];
  }
  let t42;
  if ($[94] !== t) {
    t42 = t(_temp28);
    $[94] = t;
    $[95] = t42;
  } else {
    t42 = $[95];
  }
  let t43;
  if ($[96] !== t41 || $[97] !== t42) {
    t43 = {
      description: t41,
      expression: t42
    };
    $[96] = t41;
    $[97] = t42;
    $[98] = t43;
  } else {
    t43 = $[98];
  }
  let t44;
  if ($[99] !== t) {
    t44 = t(_temp29);
    $[99] = t;
    $[100] = t44;
  } else {
    t44 = $[100];
  }
  let t45;
  if ($[101] !== t) {
    t45 = t(_temp30);
    $[101] = t;
    $[102] = t45;
  } else {
    t45 = $[102];
  }
  let t46;
  if ($[103] !== t44 || $[104] !== t45) {
    t46 = {
      description: t44,
      expression: t45
    };
    $[103] = t44;
    $[104] = t45;
    $[105] = t46;
  } else {
    t46 = $[105];
  }
  let t47;
  if ($[106] !== t) {
    t47 = t(_temp31);
    $[106] = t;
    $[107] = t47;
  } else {
    t47 = $[107];
  }
  let t48;
  if ($[108] !== t) {
    t48 = t(_temp32);
    $[108] = t;
    $[109] = t48;
  } else {
    t48 = $[109];
  }
  let t49;
  if ($[110] !== t47 || $[111] !== t48) {
    t49 = {
      description: t47,
      expression: t48
    };
    $[110] = t47;
    $[111] = t48;
    $[112] = t49;
  } else {
    t49 = $[112];
  }
  let t50;
  if ($[113] !== t) {
    t50 = t(_temp33);
    $[113] = t;
    $[114] = t50;
  } else {
    t50 = $[114];
  }
  let t51;
  if ($[115] !== t) {
    t51 = t(_temp34);
    $[115] = t;
    $[116] = t51;
  } else {
    t51 = $[116];
  }
  let t52;
  if ($[117] !== t50 || $[118] !== t51) {
    t52 = {
      description: t50,
      expression: t51
    };
    $[117] = t50;
    $[118] = t51;
    $[119] = t52;
  } else {
    t52 = $[119];
  }
  let t53;
  if ($[120] !== t10 || $[121] !== t13 || $[122] !== t16 || $[123] !== t19 || $[124] !== t22 || $[125] !== t25 || $[126] !== t28 || $[127] !== t31 || $[128] !== t34 || $[129] !== t37 || $[130] !== t4 || $[131] !== t40 || $[132] !== t43 || $[133] !== t46 || $[134] !== t49 || $[135] !== t52 || $[136] !== t7) {
    t53 = [t4, t7, t10, t13, t16, t19, t22, t25, t28, t31, t34, t37, t40, t43, t46, t49, t52];
    $[120] = t10;
    $[121] = t13;
    $[122] = t16;
    $[123] = t19;
    $[124] = t22;
    $[125] = t25;
    $[126] = t28;
    $[127] = t31;
    $[128] = t34;
    $[129] = t37;
    $[130] = t4;
    $[131] = t40;
    $[132] = t43;
    $[133] = t46;
    $[134] = t49;
    $[135] = t52;
    $[136] = t7;
    $[137] = t53;
  } else {
    t53 = $[137];
  }
  const examples = t53;
  let t54;
  if ($[138] !== t) {
    t54 = t(_temp35);
    $[138] = t;
    $[139] = t54;
  } else {
    t54 = $[139];
  }
  let t55;
  if ($[140] !== t) {
    t55 = t(_temp36);
    $[140] = t;
    $[141] = t55;
  } else {
    t55 = $[141];
  }
  let t56;
  if ($[142] !== t55) {
    t56 = <p className="text-body-2">{t55}</p>;
    $[142] = t55;
    $[143] = t56;
  } else {
    t56 = $[143];
  }
  let t57;
  if ($[144] !== t) {
    t57 = t(_temp37);
    $[144] = t;
    $[145] = t57;
  } else {
    t57 = $[145];
  }
  let t58;
  if ($[146] !== t57) {
    t58 = <LinkButton href="https://github.com/google/cel-spec/blob/master/doc/langdef.md" target="_blank" variant="body-3" iconComponent={IcoArrowTopRight16} iconPosition="right">{t57}</LinkButton>;
    $[146] = t57;
    $[147] = t58;
  } else {
    t58 = $[147];
  }
  let t59;
  if ($[148] !== t56 || $[149] !== t58) {
    t59 = <div className="flex flex-col gap-2">{t56}{t58}</div>;
    $[148] = t56;
    $[149] = t58;
    $[150] = t59;
  } else {
    t59 = $[150];
  }
  let t60;
  if ($[151] !== t) {
    t60 = t(_temp38);
    $[151] = t;
    $[152] = t60;
  } else {
    t60 = $[152];
  }
  let t61;
  if ($[153] !== t60) {
    t61 = <p className="text-label-2">{t60}</p>;
    $[153] = t60;
    $[154] = t61;
  } else {
    t61 = $[154];
  }
  let t62;
  if ($[155] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = <li><Trans ns="playbook-builder" i18nKey={_temp39} components={{
        code: <code className="text-snippet-2 px-1 rounded bg-secondary" />
      }} /></li>;
    $[155] = t62;
  } else {
    t62 = $[155];
  }
  let t63;
  if ($[156] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = <li><Trans ns="playbook-builder" i18nKey={_temp40} components={{
        code: <code className="text-snippet-2 px-1 rounded bg-secondary" />
      }} /></li>;
    $[156] = t63;
  } else {
    t63 = $[156];
  }
  let t64;
  if ($[157] !== t) {
    t64 = t(_temp41);
    $[157] = t;
    $[158] = t64;
  } else {
    t64 = $[158];
  }
  let t65;
  if ($[159] !== t64) {
    t65 = <li>{t64}</li>;
    $[159] = t64;
    $[160] = t65;
  } else {
    t65 = $[160];
  }
  let t66;
  if ($[161] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = <li><Trans ns="playbook-builder" i18nKey={_temp42} components={{
        code: <code className="text-snippet-2 px-1 rounded bg-secondary" />
      }} /></li>;
    $[161] = t66;
  } else {
    t66 = $[161];
  }
  let t67;
  if ($[162] !== t65) {
    t67 = <ul className="list-disc pl-5 flex flex-col gap-1 text-body-2">{t62}{t63}{t65}{t66}</ul>;
    $[162] = t65;
    $[163] = t67;
  } else {
    t67 = $[163];
  }
  let t68;
  if ($[164] !== t61 || $[165] !== t67) {
    t68 = <div className="flex flex-col gap-3">{t61}{t67}</div>;
    $[164] = t61;
    $[165] = t67;
    $[166] = t68;
  } else {
    t68 = $[166];
  }
  let t69;
  if ($[167] !== t) {
    t69 = t(_temp43);
    $[167] = t;
    $[168] = t69;
  } else {
    t69 = $[168];
  }
  let t70;
  if ($[169] !== t69) {
    t70 = <p className="text-label-2">{t69}</p>;
    $[169] = t69;
    $[170] = t70;
  } else {
    t70 = $[170];
  }
  let t71;
  if ($[171] !== examples) {
    t71 = <div className="flex flex-col gap-3">{examples.map(_temp44)}</div>;
    $[171] = examples;
    $[172] = t71;
  } else {
    t71 = $[172];
  }
  let t72;
  if ($[173] !== t70 || $[174] !== t71) {
    t72 = <div className="flex flex-col gap-3">{t70}{t71}</div>;
    $[173] = t70;
    $[174] = t71;
    $[175] = t72;
  } else {
    t72 = $[175];
  }
  let t73;
  if ($[176] !== t59 || $[177] !== t68 || $[178] !== t72) {
    t73 = <div className="flex flex-col gap-6">{t59}{t68}{t72}</div>;
    $[176] = t59;
    $[177] = t68;
    $[178] = t72;
    $[179] = t73;
  } else {
    t73 = $[179];
  }
  let t74;
  if ($[180] !== onClose || $[181] !== open || $[182] !== t54 || $[183] !== t73) {
    t74 = <Dialog open={open} onClose={onClose} title={t54} size="default" isConfirmation={true}>{t73}</Dialog>;
    $[180] = onClose;
    $[181] = open;
    $[182] = t54;
    $[183] = t73;
    $[184] = t74;
  } else {
    t74 = $[184];
  }
  return t74;
};
export default CelInstructionsDialog;
function _temp($) {
  return $.examples.ternary.description;
}
function _temp2($_0) {
  return $_0.examples.ternary.expression;
}
function _temp3($_1) {
  return $_1.examples.compare.description;
}
function _temp4($_2) {
  return $_2.examples.compare.expression;
}
function _temp5($_3) {
  return $_3.examples.logical.description;
}
function _temp6($_4) {
  return $_4.examples.logical.expression;
}
function _temp7($_5) {
  return $_5.examples.nullCheck.description;
}
function _temp8($_6) {
  return $_6.examples.nullCheck.expression;
}
function _temp9($_7) {
  return $_7.examples.stringToInt.description;
}
function _temp10($_8) {
  return $_8.examples.stringToInt.expression;
}
function _temp11($_9) {
  return $_9.examples.parseJson.description;
}
function _temp12($_10) {
  return $_10.examples.parseJson.expression;
}
function _temp13($_11) {
  return $_11.examples.toJson.description;
}
function _temp14($_12) {
  return $_12.examples.toJson.expression;
}
function _temp15($_13) {
  return $_13.examples.split.description;
}
function _temp16($_14) {
  return $_14.examples.split.expression;
}
function _temp17($_15) {
  return $_15.examples.replace.description;
}
function _temp18($_16) {
  return $_16.examples.replace.expression;
}
function _temp19($_17) {
  return $_17.examples.lower.description;
}
function _temp20($_18) {
  return $_18.examples.lower.expression;
}
function _temp21($_19) {
  return $_19.examples.toAlpha3.description;
}
function _temp22($_20) {
  return $_20.examples.toAlpha3.expression;
}
function _temp23($_21) {
  return $_21.examples.dateFormat.description;
}
function _temp24($_22) {
  return $_22.examples.dateFormat.expression;
}
function _temp25($_23) {
  return $_23.examples.parseEmailDomain.description;
}
function _temp26($_24) {
  return $_24.examples.parseEmailDomain.expression;
}
function _temp27($_25) {
  return $_25.examples.isDisposableEmail.description;
}
function _temp28($_26) {
  return $_26.examples.isDisposableEmail.expression;
}
function _temp29($_27) {
  return $_27.examples.contains.description;
}
function _temp30($_28) {
  return $_28.examples.contains.expression;
}
function _temp31($_29) {
  return $_29.examples.matches.description;
}
function _temp32($_30) {
  return $_30.examples.matches.expression;
}
function _temp33($_31) {
  return $_31.examples.listMembership.description;
}
function _temp34($_32) {
  return $_32.examples.listMembership.expression;
}
function _temp35($_33) {
  return $_33.title;
}
function _temp36($_34) {
  return $_34.description;
}
function _temp37($_35) {
  return $_35.specLink;
}
function _temp38($_36) {
  return $_36.basicsTitle;
}
function _temp39($_37) {
  return $_37.celInstructions.basics.dataAccess;
}
function _temp40($_38) {
  return $_38.celInstructions.basics.vaultAccess;
}
function _temp41($_39) {
  return $_39.basics.dataKey;
}
function _temp42($_40) {
  return $_40.celInstructions.basics.lastValue;
}
function _temp43($_41) {
  return $_41.examplesTitle;
}
function _temp44(example) {
  return <div key={example.expression} className="flex flex-col gap-1"><p className="text-body-2 text-secondary">{example.description}</p><pre className="bg-secondary border border-tertiary rounded p-2 text-snippet-2 whitespace-pre-wrap break-words"><code>{example.expression}</code></pre></div>;
}